import { render } from "./PeripheralChips.vue?vue&type=template&id=7b431a0b&scoped=true&ts=true"
import script from "./PeripheralChips.vue?vue&type=script&lang=ts"
export * from "./PeripheralChips.vue?vue&type=script&lang=ts"

import "./PeripheralChips.vue?vue&type=style&index=0&id=7b431a0b&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b431a0b"],['__file',"src/components/PeripheralChips.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "7b431a0b"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('7b431a0b', __exports__)) {
    api.reload('7b431a0b', __exports__)
  }
  
  module.hot.accept("./PeripheralChips.vue?vue&type=template&id=7b431a0b&scoped=true&ts=true", () => {
    api.rerender('7b431a0b', render)
  })

}


export default __exports__